import React, { useState, useEffect, useRef } from "react";
import "../Styles/ADCGridLeftLayout.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faMicrophone } from "@fortawesome/free-solid-svg-icons"; // audio icon
import fetchConversationData from "../Utils/UserAudioLoadChatHistory";
import "../../../Styles/common-styles.css";
import RenderGroupConversationContent from "../Utils/RenderGroupConversationContent";
import "../../Styles/uac-common-styles.css";
import kleidologo from "../../../../../assets/images/Kleido.png" 

const UMGridLeftLayout = ({ recipientId, mode }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [profileImage] = useState("/assets/Profile/profile-biker.jpeg");
  const [conversations, setConversations] = useState({});
  const [submode, setSubmode] = useState("groupchat");
  const [chatInput, setChatInput] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const chatHistoryRef = useRef(null);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setSubmode(value.trim() !== "" ? "searchkey" : "groupchat");
  };

  const handleMemberChatClick = () => {
    setSubmode("memberchat");
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchConversationData();
      if (typeof data !== "object") {
        throw new Error("Invalid JSON structure");
      }
      setConversations(data);
      // Flatten all messages for demo/chat panel display:
      if (data?.conversations) {
        const flatMessages = [];
        data.conversations.forEach((conv) => {
          conv.allmessages?.forEach((entry) => {
            entry.messages?.forEach((msg) => {
              flatMessages.push({ ...msg, date: entry.date, month: conv.month });
            });
          });
        });
        setChatHistory(flatMessages);
      }
    };
    fetchData();
  }, []);

  // Handle sending new chat message (text for now)
  const handleSendChat = () => {
    if (chatInput.trim()) {
      const newMsg = {
        id: Date.now(),
        sender: recipientId,
        content: chatInput,
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString(),
      };
      setChatHistory((prev) => [...prev, newMsg]);
      setChatInput("");
      // Scroll to bottom
      setTimeout(() => {
        if (chatHistoryRef.current) {
          chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
        }
      }, 100);
    }
  };

  // Handler for "audio call" button
  const handleAudioCall = () => {
    alert("Audio call feature coming soon!");
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      height: "auto",
      width: "100%",
      position: "relative",
      background: "black",
      borderRadius: 20,
      padding: 0,
    }}>
      {/* Top Profile & Search */}
      <div className="uac-profile-section" style={{ flex: "0 0 auto", paddingBottom: 20 }}>
        <img src={kleidologo} alt="Profile" className="uac-profile-pic" />

        <h2 className="subgroup-header" style={{ fontSize: 21, color: "#fff", marginLeft: 10, marginTop: 30 }}>
          Chat History
        </h2>

        <button
          style={{
            position: "absolute",
            right: "28px",
            top: "30px",
            background: "rgba(36,36,45,0.2)",
            color: "white",
            borderRadius: "40%",
            width: "42px",
            height: "42px",
            border: "1px solid gray",
            fontSize: 22,
            fontWeight: "bold",
            zIndex: 999,
            cursor: "pointer"
          }}
          onClick={handleAudioCall}
          title="Start audio call"
        >
          <FontAwesomeIcon icon={faMicrophone} style={{color: "white"}}/>
        </button>
      </div>

      <div className="uac-search-bar" style={{ width: "100%", height: 60 }}>
        <input
          className="uac-search-input-container"
          placeholder="Search chat history..."
          value={searchTerm}
          onChange={handleSearchChange}
          style={{marginLeft: 20}}
        />
        <button
          className="Member-Chat-Click-container"
          onClick={handleMemberChatClick}
          style={{ background: "none", marginTop: 20, border: "1px solid gray" }}
        >
          +
        </button>
      </div>

      {/* Scrollable chat history area */}
      <div
        ref={chatHistoryRef}
        className="adc-chat-history-scroll"
        style={{
          minHeight: 0,
          overflowY: "auto",
          background: "#191919",
          borderRadius: 10,
          margin: "13px 8px",
          padding: "3px 12px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.22)",
          height: 490
        }}
      >
        {chatHistory.length === 0 && <div style={{ color: "#aaa", margin: 18 }}>No messages yet.</div>}
        <ul className="message-list">
          {chatHistory.map((msg) => (
            <li key={msg.id} className="message-item" style={{marginBottom:6, color:"#eee"}}>
              <span style={{fontWeight:"bold", color:"gray"}}>{msg.sender}</span>:
              <span style={{marginLeft:8}}>{msg.content}</span>
              <span style={{marginLeft:12, fontSize:12, color:"#888"}}>
                {msg.date} {msg.time}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Input for chat at bottom */}
      <div className="chat-input-bar" style={{
        flex: "0 0 auto",
        width: "98%",
        padding: "12px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        background: "#2b2d34",
        margin: "0 8px",
        borderRadius: "10px",
        boxShadow: "0px 0px 2px #222"
      }}>
        <input
          type="text"
          value={chatInput}
          onChange={e => setChatInput(e.target.value)}
          placeholder="Type your message..."
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #444",
            background: "#111",
            color: "#eee",
            fontSize: 15,
          }}
          onKeyUp={e => { if (e.key === "Enter") handleSendChat(); }}
        />
        <button
          className="send-chat-button"
          onClick={handleSendChat}
          style={{
            background: "#29e6e6",
            color: "#232323",
            borderRadius: "8px",
            padding: "0 18px",
            fontWeight: "bold",
            fontSize: 15,
            border: "none",
            cursor: "pointer",
            minWidth: "60px",
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default UMGridLeftLayout;
